// extracted by mini-css-extract-plugin
module.exports = {"consume":"Consume-module--consume--2iTKp","info":"Consume-module--info--1pw7i","filewrapper":"Consume-module--filewrapper--ehxyT","feedback":"Consume-module--feedback--3BZhL"};